/* ============
 * Rule Transformer
 * ============
 *
 * The transformer for the rule.
 */

import Transformer from './Transformer';

export const CRITERIA = Object.freeze({
  PERIOD: 'PeriodCriteria',
  DOCTYPE: 'DocTypeCriteria',
  ORGANIZATION: 'OrgsCriteria',
  METADATA: 'MetaDataCriteria',
/*  PARTNERS: 'PartnersCriteria', */
});

export default class RuleTransformer extends Transformer {

  /**
   * Method used to transform a fetched rule.
   *
   * @param rule The fetched rule.
   *
   * @returns {Object} The transformed rule.
   */
  static fetch(rule) {
    const result = {
      name: rule.accessRule.name,
      orgId: rule.accessRule.orgId,
      userIds: rule.accessRule.userIds,
      userGroupIds: rule.accessRule.userGroupIds,
      users: rule.accessRule.userIds.map(userId => ({
        id: userId,
        name: rule.userDetails[userId].name,
        firstName: rule.userDetails[userId].firstName,
      })),
      groups: rule.accessRule.userGroupIds.map(groupId => ({
        id: groupId,
        name: rule.userGroupDetails[groupId].name,
      })),

      features: rule.accessRule.features,
      docCriterias: rule.accessRule.docCriterias.map(criteria =>
       RuleTransformer.transformCriteriaToFetch(rule, criteria)),
      empDetails: !rule.empDetails ||
        Object.keys(rule.empDetails).length === 0 ?
        undefined : rule.empDetails,
      empGroupsDetails: !rule.empGroupsDetails ||
        Object.keys(rule.empGroupsDetails).length === 0 ?
        undefined : rule.empGroupsDetails,
      orgDetails: !rule.orgDetails ||
        Object.keys(rule.orgDetails).length === 0 ?
        undefined : rule.orgDetails,
    };
    return JSON.parse(JSON.stringify(result));
  }

  static transformCriteriaToFetch(rule, criteria) {
    const criteriaType = Object.keys(criteria)[0];
    const criteriaValue = Object.values(criteria)[0];
    const result = {};
    if (criteriaType === CRITERIA.PERIOD) {
      result.name = criteriaType;
      result.value =
      {
        start: criteriaValue.periods[0].start,
        end: criteriaValue.periods[0].end,
      };
      return result;
    } else if (criteriaType === CRITERIA.ORGANIZATION) {
      result.name = criteriaType;
      result.value = [];
      Object.keys(rule.orgDetails).forEach((key) => {
        result.value.push(
          {
            id: key,
            name: rule.orgDetails[key].name,
          },
        );
      });
      return result;
    }
    return {
      name: criteriaType,
      value: criteriaValue,
    };
  }

  static transformCriteriasToSend(criterias) {
    if (!Array.isArray(criterias)) return {};

    const docCriterias = [];
    const periods = [];
    let orgIds = [];

    for (let i = 0; i < criterias.length; i += 1) {
      if (criterias[i].name === CRITERIA.PERIOD) {
        if (criterias[i].value.start && criterias[i].value.end) {
          periods.push({ start: new Date(criterias[i].value.start).toISOString().slice(0, -1),
            end: new Date(criterias[i].value.end).toISOString().slice(0, -1) });
        } else if (criterias[i].value.start) {
          periods.push({ start: new Date(criterias[i].value.start).toISOString().slice(0, -1) });
        } else if (criterias[i].value.end) {
          periods.push({ end: new Date(criterias[i].value.end).toISOString().slice(0, -1) });
        }
      } else if (criterias[i].name === CRITERIA.DOCTYPE) {
        docCriterias.push({ DocTypeCriteria: criterias[i].value });
      } else if (criterias[i].name === CRITERIA.ORGANIZATION) {
        orgIds = orgIds.concat(criterias[i].value.map(item => item.id));
      } else if (criterias[i].name === CRITERIA.METADATA) {
        const MetaDataCriteria = criterias[i].value;
        docCriterias.push({ MetaDataCriteria });
      }
    }
    if (periods.length > 0) {
      const PeriodCriteria = {};
      PeriodCriteria.periods = periods;
      docCriterias.push({ PeriodCriteria });
    }
    if (orgIds.length > 0) {
      const OrgsCriteria = {};
      OrgsCriteria.orgIds = orgIds;
      docCriterias.push({ OrgsCriteria });
    }
    return docCriterias;
  }

  /**
   * Method used to transform a send a rule.
   *
   * @param rule The rule to be send.
   *
   * @returns {Object} The transformed rule.
   */
  static send(rule) {
    return {
      name: rule.name,
      userIds: rule.userIds,
      userGroupIds: rule.userGroupIds,
      features: rule.features,
      orgId: rule.orgId,
      docCriterias: RuleTransformer.transformCriteriasToSend(rule.docCriterias),
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/RuleTransformer.js